module.exports = __webpack_public_path__ + "static/media/logos-harineradechiapas.14e8640a.png";